
export default {
  SET_NEXT_SEQ_CODE: (state, payload) => state.nextSeqCode = payload,
  SET_ACTIVITY_CATEGORIES: (state, payload) => state.activityCategories = payload,

}